import { LogHttpError } from "@/models/decorators/http.decorators";
import axios, { AxiosResponse } from "axios";
import { AddressInputContainer } from "../entity-settings";

export interface LoginHttpRequest  {
    // jwt: string;
    base_url: string;
    // use_token: boolean;
}
export interface LoginRequest {
  ChangerId: number;
  SessionKey: string;
}

export interface SingleIdRequest extends LoginRequest {
  Id: number;
}

export interface PersonEditRequest {
    PersonId: number,
    Name: string;
    Post: string;
    Contacts: string;
    InputContainer: AddressInputContainer;
    Tags: string[];
}

export class LoginHttp implements LoginHttpRequest {
  // jwt = ''
  base_url = ''
  // use_token = true
  old = false

  constructor (baseUrl: string, old_api: boolean = false) {
    this.base_url = baseUrl
    // this.jwt = baseJwt
    this.old = old_api
  }

  private getHeaders() {
    return {
      ...(this.old ? { 'Content-Type': 'application/json' } : {}),
      // ...(this.use_token ? { Authorization: 'Bearer '+this.jwt } : {})
    }
  }

  @LogHttpError([404, 400, 401, 490, 500])
  get(url: string, opts: any = {}): Promise<AxiosResponse<any, any>> {
    return axios.get(this.base_url + '/' + url, {
      headers: this.getHeaders(),
      ...opts
    })
  }

  @LogHttpError([404, 400, 401, 490, 500])
  post(url: string, data: any, opts: any = {}): Promise<AxiosResponse<any, any>> {
    return axios.post(this.base_url + '/' + url, data, {
      headers: this.getHeaders(),
      ...opts
    })
  }

  @LogHttpError([404, 400, 401, 490, 500])
  put(url: string, data: any, opts: any = {}): Promise<AxiosResponse<any, any>> {
    return axios.put(this.base_url + '/' + url, data, {
      headers: this.getHeaders(),
      ...opts
    })
  }

  @LogHttpError([404, 400, 401, 490, 500])
  delete(url: string): Promise<AxiosResponse<any, any>> {
    return axios.delete(this.base_url + '/' + url, {
      headers: this.getHeaders()
    })
  }
}